import { Disruption } from '@/types/disruptions'
import { FilterFn } from '@tanstack/react-table'

const hasIntersection = (array1: string[], array2: string[]) => array1.some((item) => array2.includes(item))

export const filterDisruptionsByArea = (selectedAreaCode: string, areaRoutes: string[]): FilterFn<Disruption> => {
    return (row) => {
        if (selectedAreaCode === 'all') {
            return true
        }

        return hasIntersection(
            areaRoutes,
            row.original.routes.flatMap((route) => route.route)
        )
    }
}
